export default "__VITE_ASSET__Burag1Jr__"